import React from 'react';
import './BeeLogo.css';

interface BeeLogoProps {
  variant?: 'login' | 'header';
  showText?: boolean;
}

const BeeLogo: React.FC<BeeLogoProps> = ({ variant = 'header', showText = false }) => {
  const isLogin = variant === 'login';
  
  return (
    <div className={`bee-logo-container ${variant}`}>
      {showText && (
        <h1 className="bee-title">
          Smart Bee Management<br />
          <span>HiveTrack</span>
        </h1>
      )}
      
      <div className="bee">
        <div className="antennae"></div>  
        <div className="wing one"></div>
        <div className="wing two"></div>
      </div>
      
      <div className="shadow"></div>
      {isLogin && <div className="background-gradient"></div>}
    </div>
  );
};

export default BeeLogo;
